import { config } from '$lib/config';
import type { SignupRequest, ProgressData, ApiResponse } from '$lib/types';

const apiUrl = (path: string) => `${config.apiBase}${path}`;

export async function signup(data: SignupRequest): Promise<ApiResponse> {
  try {
    const response = await fetch(apiUrl('/signup'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      return { success: false, error: 'Signup failed' };
    }

    return { success: true };
  } catch (error) {
    return { success: false, error: 'Network error' };
  }
}

export async function requestData(email: string): Promise<ApiResponse> {
  try {
    const response = await fetch(apiUrl('/data-request'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    });

    if (!response.ok) {
      return { success: false, error: 'Request failed' };
    }

    return { success: true };
  } catch (error) {
    return { success: false, error: 'Network error' };
  }
}

export async function getProgress(year: number, month: number): Promise<ApiResponse<ProgressData>> {
  try {
    const response = await fetch(apiUrl(`/progress/${year}/${month}`));
    
    if (!response.ok) {
      return { success: false, error: 'Failed to load progress' };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    return { success: false, error: 'Network error' };
  }
}
